import React from "react";
import ReactDOM from "react-dom";
import styles from "../styles/components/reclamation.module.scss";
import { useTranslation } from "react-i18next";

const PhotoPickerDialog = ({ open, onClose, onPickCamera, onPickGallery }) => {
  const { t, i18n } = useTranslation();

  if (!open) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.dialog}>
        <h3 className={styles.titleDialogPicker}>{t("takePhoto")}</h3>
        <button className={styles.optionBtn} onClick={onPickCamera}>
          📷 {t("fromCamera")}
        </button>
        <button className={styles.optionBtn} onClick={onPickGallery}>
          📁 {t("fromDevice")}
        </button>
        <button className={styles.cancelBtn} onClick={onClose}>
          {t("cancel")}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default PhotoPickerDialog;
